import React from 'react'

const Cardapio = () => {
  return (
    <div>Cardapio</div>
  )
}
export default Cardapio;